import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from 'react-router-dom'
import { getBudgetError } from '../selectors'
import { setBudgetIgnore } from '../actions'
import BudgetError from '../components/budgetError'

const mapStateToProps = state => ({
  budgetError: getBudgetError(state),
})

const mapDispatchToProps = dispatch => ({
  setBudgetIgnore: (payload) => {
    dispatch(setBudgetIgnore(payload))
  },
})

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(BudgetError)



// WEBPACK FOOTER //
// ./src/modules/budget/containers/budgetError.js